<template>
  <component :is="tag" :class="$style.tile" @click="$emit('click')">
    <div :class="$style.wrapper">
      <div v-if="icon" :class="$style.icon">
        <b-svg
          :name="icon"
          :size="32"
        />
      </div>
      <div class="flex flex-col flex-1">
        <div v-if="$slots.status" class="mb-2">
          <slot name="status" />
        </div>

        <h3
          :class="$style.title"
          v-if="title"
          data-testid="title"
        >
          {{ title }}
        </h3>
        <div
          :class="$style.description"
          v-if="description"
          data-testid="description"
        >
          {{ description }}
        </div>
      </div>
      <b-svg
        v-if="iconRight"
        :class="$style.iconRight"
        :name="iconRight"
      />
    </div>

    <div v-if="$slots.default" class="mt-4">
      <slot name="default" />
    </div>
  </component>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
export default defineComponent({

  emits: [
    'click',
  ],
  name: 'b-tile',
  props: {
    tag: {
      type: String,
      default: 'div',
      validator: (v: string) => ['div', 'button', 'a'].includes(v),
    },
    title: {
      type: String,
      default: null,
    },
    description: {
      type: String,
      default: null,
    },
    icon: {
      type: String,
      default: null,
    },
    iconRight: {
      type: String,
      default: 'chevron-right-small',
    },
  },
  methods: {},
})

</script>

<style lang="scss" module>
@layer legacy-views {

.tile {
  --b-tile-padding: var(--b-gap-6);
  display: flex;
  flex-direction: column;
  padding: var(--b-tile-padding);
  background: var(--b-color-bg-card);
  color: var(--b-color-text);
  border-radius: var(--b-border-radius-lg);
  box-shadow: var(--b-shadow-card);

  &:hover {
    cursor: pointer;

    .iconRight {
      transform: translateX(var(--b-gap-2));
    }
  }
}

.wrapper {
  display: flex;
  flex-direction: row;
  gap: var(--b-gap-6);
  align-items: center;
}

.icon {
  width: 2rem;
  height: 2rem;
  display: flex;
  align-items: center;
  justify-content: center;
  align-self: flex-start;

  &Right {
    color: var(--b-color-text);
    align-self: center;
    width: 1.5rem;
    height: 1.5rem;
    transition: var(--b-transition) transform;
  }
}

.title {
  font-weight: var(--b-font-weight-medium);
  font-size: var(--b-font-size-h4);
  line-height: var(--b-line-height-h4);
}

.description {
  color: var(--b-color-secondary);
  margin-top: var(--b-gap-2);
  font-size: var(--b-font-size-h6);
}

}</style>
